import { Tag } from 'antd';

const MovieCard = ({currentMovie, currentShow}) => {
  return (
    <div className='movie-card'>
         <img src={currentMovie.banner} alt="" className='ban'/>
        <img src={currentMovie.thumbnail} alt="" className='thumb'/>
        <div className='text-detail'>
            <h1>{currentMovie.name}</h1>
            <small>About: {currentMovie.about}</small>
            <p>Theater: {currentShow.theatre_name}</p>
            <p>Screen: {currentShow.screen_name}</p>
            <div >
                <Tag color="magenta">{currentMovie.age}+</Tag>
                <Tag color="red">{currentMovie.duration}</Tag>
                <Tag color="volcano">{currentMovie.display_language}</Tag>
            </div>
        </div>
    </div>
  )
}

export default MovieCard
